var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                { staticClass: "search-section" },
                [
                  _c("div", { staticClass: "search-header" }, [
                    _c("div", { staticClass: "search-title" }, [
                      _c("i", { staticClass: "el-icon-search" }),
                      _vm._v("\n          筛选搜索\n        "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      attrs: { inline: "", size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKUID：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.skuId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "skuId", $$v)
                              },
                              expression: "listPram.skuId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SPU编码：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.spuCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "spuCode", $$v)
                              },
                              expression: "listPram.spuCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKU编码：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.skuCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "skuCode", $$v)
                              },
                              expression: "listPram.skuCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.spuName,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "spuName", $$v)
                              },
                              expression: "listPram.spuName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.handerSearch },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetSearch },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "toolbar-row" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["admin:store:card:inventory:save"],
                              expression: "['admin:store:card:inventory:save']",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.handleAddCard },
                        },
                        [_vm._v("添加卡密")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["admin:store:card:inventory:batch"],
                              expression:
                                "['admin:store:card:inventory:batch']",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.handleBatchCard },
                        },
                        [_vm._v("生成批次卡密")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-section" },
                [
                  _c("div", { staticClass: "table-header" }, [
                    _c("div", { staticClass: "table-title" }, [
                      _c("i", { staticClass: "el-icon-s-grid" }),
                      _vm._v("\n          数据列表\n        "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:store:card:inventory:log"],
                                expression:
                                  "['admin:store:card:inventory:log']",
                              },
                            ],
                            attrs: { size: "small" },
                            on: { click: _vm.handleOperationLog },
                          },
                          [_vm._v("操作日志")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      staticClass: "table",
                      attrs: {
                        data: _vm.listData.list,
                        size: "mini",
                        border: "",
                        "header-cell-style": {
                          fontWeight: "600",
                          background: "#f8fafc",
                          color: "#2d3748",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuId",
                          label: "SKUID",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "spuCode",
                          label: "SPU编码",
                          "min-width": "120",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuCode",
                          label: "SKU编码",
                          "min-width": "160",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productName",
                          label: "商品名称",
                          "min-width": "180",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cardTypeDesc",
                          label: "卡密类型",
                          "min-width": "110",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "defaultPrice",
                          label: "售价￥",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.defaultPrice != null
                                        ? Number(
                                            scope.row.defaultPrice
                                          ).toFixed(2)
                                        : "-"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuName",
                          label: "规格",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "stock",
                          label: "库存量",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remark",
                          label: "备注",
                          "min-width": "160",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "创建时间",
                          "min-width": "160",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "updateTime",
                          label: "最后更新时间",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.updateTime || "-")),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "100", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "admin:store:card:inventory:detail",
                                        ],
                                        expression:
                                          "['admin:store:card:inventory:detail']",
                                      },
                                    ],
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleStockDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("库存详情")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.listPram.page,
                          "page-sizes": _vm.constants.page.limit,
                          layout: _vm.constants.page.layout,
                          total: _vm.listData.total,
                          background: "",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加卡密",
            visible: _vm.addDialogVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
            closed: _vm.resetAddForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              attrs: {
                model: _vm.addForm,
                rules: _vm.addRules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称：", prop: "skuId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full",
                      attrs: {
                        placeholder: "请选择商品",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.addForm.skuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "skuId", $$v)
                        },
                        expression: "addForm.skuId",
                      },
                    },
                    _vm._l(_vm.addProductOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "卡密类型：", prop: "cardType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onCardTypeChange },
                      model: {
                        value: _vm.addForm.cardType,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "cardType", $$v)
                        },
                        expression: "addForm.cardType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("自营一卡通"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("美景一卡通"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.addForm.cardType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "使用有效期：", prop: "validityRange" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "full",
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.addForm.validityRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "validityRange", $$v)
                          },
                          expression: "addForm.validityRange",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticClass: "full",
                    attrs: {
                      placeholder: "请输入备注",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.addForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "remark", $$v)
                      },
                      expression: "addForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:store:card:inventory:save"],
                      expression: "['admin:store:card:inventory:save']",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.addSubmitting },
                  on: { click: _vm.submitAdd },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "生成批次卡密",
            visible: _vm.batchDialogVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchDialogVisible = $event
            },
            closed: _vm.resetBatchForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "batchFormRef",
              attrs: {
                model: _vm.batchForm,
                rules: _vm.batchRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "生成卡密类型：", prop: "channelType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.batchForm.channelType,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchForm, "channelType", $$v)
                        },
                        expression: "batchForm.channelType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("小程序"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "关联商品：", prop: "skuId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full",
                      attrs: {
                        placeholder: "请选择商品",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.batchForm.skuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchForm, "skuId", $$v)
                        },
                        expression: "batchForm.skuId",
                      },
                    },
                    _vm._l(_vm.batchProductOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生成数量：", prop: "generateCount" } },
                [
                  _c("el-input-number", {
                    staticClass: "full",
                    attrs: { min: 1, max: 5000, "controls-position": "right" },
                    model: {
                      value: _vm.batchForm.generateCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchForm, "generateCount", $$v)
                      },
                      expression: "batchForm.generateCount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "一卡通有效期：", prop: "expiryType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onExpiryTypeChange },
                      model: {
                        value: _vm.batchForm.expiryType,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchForm, "expiryType", $$v)
                        },
                        expression: "batchForm.expiryType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("永久有效"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("自定义有效期"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.batchForm.expiryType === 1
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "batch-active-days",
                      attrs: { label: "激活后天数：", prop: "validDays" },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "batch-days-input",
                        attrs: {
                          min: 1,
                          max: 9999999999,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.batchForm.validDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.batchForm, "validDays", $$v)
                          },
                          expression: "batchForm.validDays",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "days-hint" }, [
                        _vm._v(
                          "激活后 " +
                            _vm._s(_vm.batchForm.validDays || 0) +
                            " 天有效（自激活当日算）"
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:store:card:inventory:batch"],
                      expression: "['admin:store:card:inventory:batch']",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.batchSubmitting },
                  on: { click: _vm.submitBatch },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }